var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingUserScope,
          expression: "loadingUserScope"
        }
      ],
      staticClass: "govgr-card"
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { xs: 20, sm: 16, md: 14, lg: 10, xl: 8 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "govgr-card govgr-card__body box-card",
                  attrs: { shadow: "hover" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("h3", { attrs: { align: "center" } }, [
                        _vm._v("Είσοδος στο eDoatap")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text item" },
                    [
                      _vm.authStep === "credentials"
                        ? _c(
                            "el-form",
                            {
                              ref: "loginForm",
                              staticClass: "ruleForm",
                              attrs: {
                                model: _vm.loginForm,
                                rules: _vm.validationRules,
                                "label-width": "80px",
                                autocomplete: "on"
                              },
                              nativeOn: {
                                submit: function($event) {
                                  $event.preventDefault()
                                },
                                keydown: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  _vm.login($event)
                                }
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Όνομα", prop: "email" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      name: "username",
                                      id: "username",
                                      "auto-complete": "username"
                                    },
                                    model: {
                                      value: _vm.loginForm.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.loginForm, "email", $$v)
                                      },
                                      expression: "loginForm.email"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "Κωδικός", prop: "password" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "password-wrapper" },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: _vm.showPassword
                                            ? "text"
                                            : "password",
                                          name: "current-password",
                                          id: "current-password",
                                          "auto-complete": "current-password"
                                        },
                                        model: {
                                          value: _vm.loginForm.password,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.loginForm,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "loginForm.password"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "password-toggle-icon",
                                          on: {
                                            click: function($event) {
                                              _vm.showPassword = !_vm.showPassword
                                            }
                                          }
                                        },
                                        [
                                          _vm.showPassword
                                            ? _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("line", {
                                                    attrs: {
                                                      x1: "1",
                                                      y1: "1",
                                                      x2: "23",
                                                      y2: "23"
                                                    }
                                                  })
                                                ]
                                              )
                                            : _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("circle", {
                                                    attrs: {
                                                      cx: "12",
                                                      cy: "12",
                                                      r: "3"
                                                    }
                                                  })
                                                ]
                                              )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        id: "loginSubmit",
                                        type: "primary"
                                      },
                                      on: { click: _vm.login }
                                    },
                                    [_vm._v("Υποβολή")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.resetForm("loginForm")
                                        }
                                      }
                                    },
                                    [_vm._v("Σβήσιμο")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.authStep === "otp"
                          ? _c(
                              "el-form",
                              {
                                ref: "otpForm",
                                staticClass: "ruleForm otp-form",
                                attrs: {
                                  model: _vm.otpForm,
                                  rules: _vm.otpValidationRules,
                                  "label-width": "80px",
                                  autocomplete: "off"
                                },
                                nativeOn: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { staticClass: "otp-top-message-item" },
                                  [
                                    _c("div", { staticClass: "otp-message" }, [
                                      _vm.otpEmailMasked
                                        ? _c("span", [
                                            _vm._v(
                                              "Έχει σταλεί κωδικός OTP στο email " +
                                                _vm._s(_vm.otpEmailMasked) +
                                                "."
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Έχει σταλεί κωδικός OTP στο email σας."
                                            )
                                          ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "OTP", prop: "otp" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "text",
                                        name: "one-time-code",
                                        id: "one-time-code",
                                        "auto-complete": "one-time-code",
                                        inputmode: "numeric",
                                        pattern: "[0-9]*",
                                        maxlength: "6"
                                      },
                                      nativeOn: {
                                        keydown: function($event) {
                                          if (
                                            !("button" in $event) &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          _vm.verifyOtp($event)
                                        }
                                      },
                                      model: {
                                        value: _vm.otpForm.otp,
                                        callback: function($$v) {
                                          _vm.$set(_vm.otpForm, "otp", $$v)
                                        },
                                        expression: "otpForm.otp"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { staticClass: "otp-actions-item" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "otp-actions" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              id: "otpSubmit",
                                              type: "primary"
                                            },
                                            on: { click: _vm.verifyOtp }
                                          },
                                          [_vm._v("Επιβεβαίωση")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            on: { click: _vm.backToCredentials }
                                          },
                                          [_vm._v("Επιστροφή")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled: _vm.resendDisabled
                                            },
                                            on: { click: _vm.resendOtp }
                                          },
                                          [
                                            _vm.resendDisabled
                                              ? _c("span", [
                                                  _vm._v(
                                                    "Επαναποστολή OTP (" +
                                                      _vm._s(
                                                        _vm.resendCountdownText
                                                      ) +
                                                      ")"
                                                  )
                                                ])
                                              : _c("span", [
                                                  _vm._v("Επαναποστολή OTP")
                                                ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm.authStep === "role"
                            ? _c(
                                "el-form",
                                {
                                  ref: "roleForm",
                                  staticClass: "ruleForm",
                                  attrs: { "label-width": "80px" },
                                  nativeOn: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Ρόλος" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "Πιέστε για επιλογή",
                                            id: "selectRole"
                                          },
                                          model: {
                                            value: _vm.role,
                                            callback: function($$v) {
                                              _vm.role = $$v
                                            },
                                            expression: "role"
                                          }
                                        },
                                        _vm._l(_vm.userScope, function(
                                          role,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: role,
                                            attrs: {
                                              label: _vm.userScopeGr[index],
                                              value: role
                                            },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !("button" in $event) &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                _vm.selectedRole(role)
                                              }
                                            }
                                          })
                                        })
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            id: "roleSelect",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.selectedRole(_vm.role)
                                            }
                                          }
                                        },
                                        [_vm._v("Επιλογή Ρόλου")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9fcfedee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcfedee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 